'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Utils


// Actions


// Constants


var _lodash = require('lodash');

var _index = require('../index');

var _index2 = _interopRequireDefault(_index);

var _errorUtil = require('../../../../../common/error/errorUtil');

var _errorUtil2 = require('../../../errorUtil');

var _rollbarService = require('../../../../analytics/rollbarService');

var _resourceActions = require('./resourceActions');

var _resourceConstants = require('./resourceConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSingleResourceConfig = function getSingleResourceConfig(resourceType, config, id) {
    return _extends({
        url: resourceType + '/' + id,
        storeServerErrors: true
    }, config);
};

var getMultiResourceConfig = function getMultiResourceConfig(resourceType, config, ids) {
    return _extends({
        url: resourceType,
        storeServerErrors: true
    }, config, {
        params: _extends({
            ids: ids.join(',')
        }, config.params)
    });
};

exports.default = function (resourceType) {
    var fetchingResource = (0, _resourceActions.makeResourceActionCreator)(resourceType, _resourceConstants.RESOURCES_FETCHING);
    var fetchedResource = (0, _resourceActions.makeResourceActionCreator)(resourceType, _resourceConstants.RESOURCES_FETCHED);
    var resourceFetchError = (0, _resourceActions.makeResourceErrorActionCreator)(resourceType);
    var staleResource = (0, _resourceActions.makeResourceStaleActionCreator)(resourceType);

    return function (_ref) {
        var dispatch = _ref.dispatch,
            _ref$config = _ref.config,
            config = _ref$config === undefined ? {} : _ref$config,
            id = _ref.id,
            ids = _ref.ids;

        var multiple = !!ids;
        var _config = multiple ? getMultiResourceConfig(resourceType, config, ids) : getSingleResourceConfig(resourceType, config, id);

        var fetchingIds = id ? [id] : ids;
        dispatch(fetchingResource({ ids: fetchingIds }));
        return (0, _index2.default)(_config).then(function (response) {
            var fetchedTime = response.data.fetchedTime;

            var errorIds = (0, _lodash.keys)(response.data.errors);
            var fetchedIds = (0, _lodash.difference)(fetchingIds, errorIds);
            if (fetchedIds.length) {
                // Deferred to ensure it occurs after any load events
                (0, _lodash.defer)(function () {
                    return dispatch(fetchedResource({ ids: fetchedIds, fetchedTime: fetchedTime }));
                });
            }

            // TODO Make this more generic
            (0, _lodash.forEach)(response.data.errors, function (errorData, elementId) {
                return dispatch(resourceFetchError({ id: elementId, err: errorData.error }));
            });

            return response;
        }).catch(function (err) {
            err.id = err.id || (0, _errorUtil.generateUniqueErrorId)();
            err.url = _config.url;

            // Only save server errors to the store if required.  By default the config is true, but it is
            // provided to prevent helper service calls such as 'fetchNextBoards' from causing many boards to
            // error when if it times out
            if (_config.storeServerErrors) {
                dispatch(resourceFetchError({ ids: fetchingIds, err: (0, _errorUtil2.extractErrorDetailsForAction)(err) }));
            } else {
                dispatch(staleResource({ ids: fetchingIds }));
            }

            (0, _rollbarService.manuallyReportError)({
                errorMessage: resourceType + ' resource fetching error: ' + err,
                error: err,
                sensitive: false
            });
            return Promise.reject(err);
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/index.js
// module id = 469
// module chunks = 0